const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.godoorly.app&pcampaignid=web_share";

// Google Play "Get it on Google Play" badge — LIVE (Play listing is public).
// Uses the official Google Play badge asset (public/google-play-badge.png),
// sized to height:40 to match the App Store badge (135x40) so the two sit as a
// matched pair. Rendered full-color and clickable (opens the Play listing),
// mirroring AppStoreBadge.
export default function GooglePlayBadge({ className = "" }) {
  return (
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label="Get Doorly on Google Play"
      style={{ display: "inline-block", lineHeight: 0 }}
    >
      {/* Full-color official Google Play asset. height:40 matches the App Store
          badge (135x40); width auto keeps the official badge's aspect ratio. */}
      <img
        src={`${process.env.PUBLIC_URL}/google-play-badge.png`}
        alt="Get it on Google Play"
        style={{ height: 40, width: "auto", display: "block" }}
      />
    </a>
  );
}
